import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Iter-55f — Global 401 session-expiry handler.
// If a call fails with 401 while the user was authenticated (mw_token
// existed in localStorage at request time), clear the stale token and
// send them to /login. Silent for:
//   • /auth/me         — AuthContext uses this to probe login state.
//   • /auth/login      — a 401 here means "wrong password", not expiry.
//   • /auth/register   — same reasoning.
// Also silent when no mw_token was set (guest/logged-out state).
// Never runs twice for the same navigation (guarded by a module flag).
let redirectingToLogin = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      const url  = err?.config?.url || "";
      const skip = url.includes("/auth/me")
                || url.includes("/auth/login")
                || url.includes("/auth/register");
      const hadToken = !!localStorage.getItem("mw_token");
      if (!skip && hadToken && !redirectingToLogin) {
        redirectingToLogin = true;
        localStorage.removeItem("mw_token");
        // Preserve where they were so the login page can bounce them
        // back after re-auth if it ever wants to.
        const next = encodeURIComponent(
          window.location.pathname + window.location.search);
        window.location.replace(`/login?session_expired=1&next=${next}`);
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
